export default {
  "short lang": "en",
  lang: "Language",
  "my finances": "My finances",
  errands: "Instructions",
  instruments: "Stock",
  reports: "Reports",
  total: "Total",
  Mln: " Mln",
  Bil: " B",
  "amount in ": "Amount in",
  incomeSinceYearBeginning: "Profitability since the beginning of the year",
  "broker account": "Broker account",
  "current balance": "Currenct balance",
  profitability: "Profitability",
  "profitability title": "Profitability",
  "blocked amount": "Blocked amount",
  "available funds": "Available funds",
  invest: "Invest",
  "deferred companies": "Deferred companies",
  back: "< Back",
  replenish: "Replenish",
  overview: "Overview",
  portfolio: "Portfolio",
  transactions: "Transactions",
  analysis: "Analysis",
  "during the period": "During the period",
  "for today": "For today",
  week: "Week",
  month: "Month",
  "half year": "Half year",
  year: "Year",
  quarter: "Quarter",
  "portfolio structure": "Portfolio structure",
  tenge: "Tenge",
  dollars: "Dollars",
  "by country": "By country",
  "by financial instruments": "By financial instruments",
  "by sector": "By sector",
  cash: "Cash",
  securities: "Securities",
  debts: "Debts",
  sale: "Sale",
  purchase: "Purchase",
  "order book": "Order book",
  direct: "Direct",
  opposite: "Opposite",
  "date of application": "Date of application",
  description: "Description",
  quantity: "Quantity",
  nominal: "Nominal",
  nominal_value: "Face value",
  price: "Price",
  sum: "Sum",
  status: "Status",

  "set of tools": "Set of tools",
  tool: "Tool",
  currency: "Currency",
  "market price": "Market price with coupon",
  favorites: "Favorites",
  buy: "Buy",

  "account reports": "Account reports",
  "facial count statement": "Facial count statement",
  "report on transactions and operations":
    "Report on transactions and operations",
  "securities and cash flow statement": "Securities and cash flow statement",
  "securities income payment notice": "Securities income payment notice",
  download: "Download",

  "my assets": "My assets",
  title: "Title",
  "purchase value": "Purchase value",
  lesion: "Lesion",
  "market cost": "Market cost",

  "select date range": "Select Date Range",
  "select date": "Select Date",
  "select broker": "Select broker",
  "select portfolio": "Select portfolio",
  entrance: "Log In",
  "user name": "User name",
  password: "Password",
  login: "Log In",
  "password recovery": "Password recovery",

  "unsubscribe text": "You have successfully unsubscribed from the newsletter",
  "national bank rate": "Rate of the national bank of the RK",

  "personal account": "Personal Account",
  contacts: "Contacts",
  "contact us": "Contact us",
  "back call": "Back call",
  "call back within 15 minutes": "Call back within 15 minutes",
  "call me back": "Call me back",
  "buy security": "Buy security",
  "add instrument": "Add instrument",

  eds: "EDC",
  "eds login": "EDS Login",
  cancel: "Cancel",
  "first name and last name": "First name and last name",
  "serial number": "Serial number",
  search: "Search",
  "Account Statement": "Account Statement",
  "Payments Of Incomes": "Payments Of Incomes",
  "Movement of securities and cash": "Movement of securities and cash",
  "Completed transactions and operations":
    "Completed transactions and operations",

  "download the app": "Download the app",
  "for more efficient work, we recommend that you download our mobile application":
    "For more efficient work, we recommend that you download our mobile application",
  "asset dynamics": "Asset dynamics",
  confirm: "Confirm",
  resend: "Resend",
  resend_text: "You will be able to resend after",
  "recovery code is incorrect": "Recovery code is incorrect",
  "incorrect user name": "Incorrect user name",
  "repeat password": "Repeat password",
  "enter new password": "Enter new password",
  "change password": "Change password",
  "passwords must match": "Passwords must match",
  "home page": "Home page",
  "password changes successfully": "Password changed successfully",
  "password changes error": "An error occurred during password recovery",
  others: "Others",
  "sec type": "Securities type",
  "deal type": "Deal type",
  "deal date": "Deal date",
  rating: "Ratings",
  "coupon rate": "Coupon rate",
  "maturity date": "Maturity date",
  "income coupon": "Accumulated coupon",
  dividends: "Dividends",
  "buy securities": "Buy securities",
  "sell securities": "Sell securities",
  issuer: "Issuer",
  "security name": "Name",
  ask: "Ask",
  bid: "Bid",
  amount: "Amount",
  "date of expiration": "Date of expiration",
  sell: "Sell",
  validity: "Validity",
  "publisher name": "Publisher name",
  algorithm: "Algorithm",
  "passwords do not match": "Passwords do not match",
  "new password": "New password",
  "old password": "Old password",
  "repeat new password": "Repeat new password",
  "password change": "Password change",
  save: "Save",
  "required field": "Required field",
  pifs: "Mutual funds",
  "holder name": "Holder name",
  "acc type": "Bank accoun type",
  "bank account": "Bank account",
  summ: "Summ",
  "payment purpose": "Payment purpose",
  "trade code": "Trade code",
  "debit type": "Debit type",
  number: "Number",
  comments: "Comment",
  annual: "Annual",
  accumulated: "Accumulated",
  category_sec: "Category",
  "interest charges": "Interest charges",

  //--------------------LKSTASKS-i18n start

  iin: "",
  "incorrect iin": "",
  "last name": "",
  "first name": "",
  patronymic: "",
  "mobile number": "",
  "email address": "",
  "incorrect form format": "",

  "register page": "",
  "individual account": "",
  "corporate account": "",

  "full name": "",
  bin: "",
  "incorrect bin": "",
  loading: "",
  error: "",
  "data sent": "",

  "register info": "",
  "short name": "",
  "legal form": "",
  "register document type": "",
  "document number": "",
  "document issuing date": "",
  "register location": "",
  "internet resource name": "",
  "choose new file": "",
  "choose file": "",
  "choose country": "",
  "website link": "",
  "id document number": "",
  "error save": "",
  "new governing body": "",

  "license info": "",
  "buss activity type": "",
  "license number": "",
  "license issue date": "",
  "license validity period": "",
  "name of the issuing authority": "",

  "register address": "",
  country: "",
  city: "",
  street: "",
  address: "",
  house: "",
  block: "",
  apartment: "",
  "post index": "",
  "address of actual": "",
  location: "",
  residence: "",
  "coincides with register address": "",
  "actual address": "",
  "register actual address": "",

  "taxpayer info": "",
  "taxpayer country": "",
  "bank details": "",
  lei: "",
  giin: "",
  "register number": "",
  "register number placeholder": "",
  "taxpayer number": "",

  "owner info": "",
  delete: "",
  "organization form": "",
  share: "",
  from: "",
  to: "",
  add: "",
  info: "",
  next: "",
  "data saved": "",
  "location address": "",
  "fill form": "",
  "cannot be lower '0%' or higher": "",

  "management structure": "",
  "managing organ name": "",
  create: "",
  continue: "",
  deleted: "",
  "delete error": "",
  "attach file": "",
  "attach files": "",

  "client representative info": "",
  "client third party info": "",
  "empty list": "",

  "branch/representative additional info": "",
  change: "",
  "branch name": "",
  "bin (if available)": "",
  "document type register confirm": "",
  "body register name": "",
  "register date (re-register)": "",
  "registered address of the branch (representative office)": "",

  "financing sources info": "",
  "income sources list": "",
  "bank account list": "",
  "choose bank": "",
  "bank name": "",
  "account number": "",
  "total annual income": "",
  "characteristics of financial condition": "",
  "your income source": "",
  "financial condition total cost": "",
  "liabilities total value": "",
  "countries main operating assets": "",
  "changes saved": "",
  "empty field": "",
  adding: "",
  "fill fields": "",
  "not chosen": "",
  "repeatedly through": "",
  "(le real estate, values, capital share)": "",
  other: "",

  "services provision procedure": "",
  contract: "",
  link: "",
  tariffs: "",
  "user manual": "",
  "send sms code": "",
  "verification code": "",
  "check code": "",
  "sms confirm sent": "",
  "input code": "",
  "confirmation code accepted": "",
  "confirmation code not accepted": "",
  wait: "",
  "confirmation code sent to number": "",
  "confirmation code not sent": "",
  "accept contract condition": "",
  "number changed": "",
  "number not saved": "",
  "register end": "",
  "go back correct": "",
  "complete registration": "",
  "application accepted": "",
  "check data/ prepare docs": "",
  "application status track": "",
  "questions by phone": "",
  "contact phone / email": "",
  "registration completed": "",
  "already uploaded": "",
  "maximum size 5mb": "",

  identification: "",
  citizenship: "",
  birthday: "",
  "birth place": "",
  "document type": "",
  series: "",
  "issue date": "",
  expires: "",
  "issued by": "",
  "visa migration card": "",
  "visa number": "",
  "document expires": "",
  "migration card number": "",

  "job info": "",
  "tax residency": "",
  "work place position": "",
  "entrepreneurial/license activity": "",
  "document photo front": "",
  "document photo back": "",
  "passport driving license internal passport": "",
  "send files": "",
  "document uploaded": "",
  "file upload error": "",
  // --------------------------------------documents
  "charter le / Regulation branch or representative office": "",
  "state register certificate": "",
  "le activity license": "",
  "holders register extract": "",
  "signatures notarized document": "",
  "non-residents register certificate": "",
  "executive body id": "",
  "beneficial le id": "",
  "consolidated financial statements": "",
  "FATCA tax form (original)": "",
  "agreement terms confirm": "",
  "le body proxy / decision": "",
  "le representative / head/ office id": "",
  "Another session started": "New session started from another device",
  "Active token not found": "Your session is over"
};
